var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"inventory"},[_c('h2',[_vm._v("- Inventory -")]),_vm._l((Object.values(
       _vm.items
      ).filter((i) => i.has)),function({ icon, description },i){return _c('div',{key:i,staticClass:"item-slot"},[_c('div',{staticClass:"inventory-item"},[_c('img',{attrs:{"src":icon}}),_c('span',[_vm._v(_vm._s(description))])])])}),_vm._l((9 -
      Object.values(_vm.items).filter((i) => i.has)
        .length),function(i){return _c('div',{key:`${i}-empty`,staticClass:"item-slot"})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }